<template>
    <v-dialog v-model="visible" persistent max-width="600px">
        <v-card>
            <v-card-title class="justify-center">
                <v-spacer/>
                <span v-if="$vuetify.breakpoint.smAndUp" class="text-h5">
                    {{ form.id ? 'Edição' : 'Cadastro' }} de Ingrediente
                </span>
                <v-spacer/>
                <v-btn icon @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text align="center" justify="center">
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            ref="nome"
                            label="Nome"
                            v-model="form.nome"
                            outlined
                            dense
                            hide-details
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            label="Descrição"
                            v-model="form.descricao"
                            rows="4"
                            clear-icon="mdi-backspace-outline"
                            clearable
                            outlined
                            dense
                            hide-details
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete
                            prepend-inner-icon="mdi-magnify"
                            v-model="form.unidade_medida_id"
                            :items="unidadesMedida"
                            :search-input.sync="searchInput"
                            @keypress.enter="$refs.salvar.$el.focus()"
                            item-text="nome"
                            item-value="id"
                            ref="unidadeMedida"
                            dense
                            label="Unidade de Medida"
                            placeholder="Selecione ou cadastre uma nova"
                            outlined
                            hide-details
                        >
                            <template #append-item>
                                <div
                                    style="font-size: 14px; font-weight: bold; padding: 14px; cursor: pointer;"
                                    @click="newUnidadeMedida"
                                >
                                    <v-icon>mdi-plus</v-icon> Cadastrar nova unidade de medida
                                </div>
                            </template>
                            <template #append-outer>
                                <v-btn
                                    icon
                                    @click="newUnidadeMedida"
                                    title="Cadastrar nova unidade de medida"
                                >
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            label="Custo de compra"
                            :prefix="moeda()"
                            v-model="form.custo_compra"
                            placeholder="0,00"
                            type="number"
                            outlined
                            dense
                            hide-details
                        />
                    </v-col>
                    <v-col cols="6" sm="4">
                        <v-text-field
                            label="Quantidade comprada"
                            v-model="form.rendimento"
                            placeholder="0"
                            type="number"
                            outlined
                            dense
                            hide-details
                        />
                    </v-col>
                    <v-col cols="6" sm="4">
                        <v-select
                            label="Comprei em"
                            v-model="unidadeCompraId"
                            :items="unidadesMedida"
                            item-text="nome"
                            item-value="id"
                            outlined
                            dense
                            hide-details
                        />
                    </v-col>
                </v-row>
                <v-row v-if="custoUnitario > 0">
                    <v-col cols="12" class="py-0">
                        <div class="caption" style="text-align: left;">
                            Custo por {{ unidadeAbrev }} = <b>{{ custoUnitarioFmt }}</b>
                            <span v-if="houveConversao" class="grey--text">
                                ({{ form.rendimento }} {{ unidadeCompraAbrev }} = {{ rendimentoConvertido }} {{ unidadeAbrev }})
                            </span>
                        </div>
                    </v-col>
                </v-row>
                <v-row v-if="controleEstoqueAtivo()">
                    <v-col cols="12" class="pb-0">
                        <v-switch
                            dense
                            inset
                            class="mt-1"
                            hide-details
                            v-model="form.controle_estoque"
                            label="Controlar estoque"
                        />
                    </v-col>
                </v-row>
                <v-expand-transition>
                    <v-row v-if="controleEstoqueAtivo() && form.controle_estoque">
                        <v-col cols="12">
                            <v-text-field
                                v-model="form.estoque"
                                label="Quantidade disponível em estoque"
                                :suffix="unidadeAbrev"
                                placeholder="0"
                                type="number"
                                outlined
                                dense
                                :hint="unidadeNome
                                    ? `Informe na unidade de medida do ingrediente (${unidadeNome})`
                                    : 'Selecione a unidade de medida acima'"
                                persistent-hint
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                v-model="form.acao_sem_estoque"
                                :items="opcoesAcaoSemEstoque"
                                label="Ao acabar o estoque"
                                outlined
                                dense
                            />
                        </v-col>
                    </v-row>
                </v-expand-transition>
                <v-row>
                    <v-col>
                        <div class="mb-6" style="border: solid 1px #999; border-radius: 5px;">
                            <b>Imagem</b>
                            <ImageInput ref="imagem" v-model="form.imagens" />
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn text color="warning" @click="$emit('close')">Cancelar</v-btn>
                <v-spacer />
                <v-btn color="success" @click="salvar" :loading="loading">
                    <v-icon>mdi-content-save</v-icon>&nbsp;Salvar
                </v-btn>
            </v-card-actions>
        </v-card>

        <CadastroUnidadeMedida
            :visible="unidadeMedidaVisible"
            :formData="formUnidadeMedida"
            @onCadastro="onCadastroUnidadeMedida"
            @close="closeUnidadeMedida"
        />
    </v-dialog>
</template>

<script>
import { codigoMoeda } from '@/utils/moeda';
import ImageInput from '@/components/ImageInput';
import CadastroUnidadeMedida from './UnidadeMedida';
import { opcoesAcaoItem } from '@/utils/estoque';

function defaultForm() {
    return {
        status: 'ativo',
        nome: '',
        descricao: null,
        imagens: [],
        unidade_medida_id: '',
        controle_estoque: false,
        estoque: 0,
        acao_sem_estoque: null,
        custo_compra: null,
        rendimento: null,
        unidade_compra_id: null,
    };
}

export default {
    name: 'Ingredientes',

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        formData: {
            type: Object,
            default: Object
        },
    },

    components: {
        ImageInput,
        CadastroUnidadeMedida,
    },

    data: () => ({
        loading: false,
        form: defaultForm(),
        searchInput: '',
        unidadesMedida: [],
        unidadeMedidaVisible: false,
        formUnidadeMedida: {},
    }),

    mounted() {
        this.fillUnidadesMedida();
        this.form = { ...defaultForm(), ...(this.formData || {}) };
    },

    watch: {
        visible(v) {
            v && setTimeout(() => this.$refs.nome.focus(), 100);
        },

        formData(value) {
            this.form = value ? { ...defaultForm(), ...value } : defaultForm();
        },
    },

    computed: {
        opcoesAcaoSemEstoque() {
            return opcoesAcaoItem();
        },

        unidadeAbrev() {
            const u = this.unidadesMedida.find(e => e.id === this.form.unidade_medida_id);
            return u ? u.abreviacao : 'un';
        },

        unidadeNome() {
            const u = this.unidadesMedida.find(e => e.id === this.form.unidade_medida_id);
            return u ? u.nome : '';
        },

        // Unidade de compra: cai na unidade do ingrediente quando não definida.
        unidadeCompraId: {
            get() {
                return this.form.unidade_compra_id || this.form.unidade_medida_id;
            },
            set(val) {
                this.form.unidade_compra_id = val;
            },
        },

        unidadeCompraAbrev() {
            const u = this.unidadesMedida.find(e => e.id === this.unidadeCompraId);
            return u ? u.abreviacao : this.unidadeAbrev;
        },

        houveConversao() {
            return this.fatorDe(this.unidadeCompraId) !== this.fatorDe(this.form.unidade_medida_id);
        },

        // custo_compra * fatorConsumo / (quantidade * fatorCompra)
        custoUnitario() {
            const compra = parseFloat(this.form.custo_compra) || 0;
            const qtd = parseFloat(this.form.rendimento) || 0;
            if (qtd <= 0) return 0;

            const fatorConsumo = this.fatorDe(this.form.unidade_medida_id);
            const fatorCompra = this.fatorDe(this.unidadeCompraId);

            return compra * fatorConsumo / (qtd * fatorCompra);
        },

        // Quantidade comprada já convertida para a unidade de consumo (ex: 1 kg = 1000 g).
        rendimentoConvertido() {
            const qtd = parseFloat(this.form.rendimento) || 0;
            const val = qtd * this.fatorDe(this.unidadeCompraId) / this.fatorDe(this.form.unidade_medida_id);
            return Number.isInteger(val) ? val : val.toFixed(2);
        },

        custoUnitarioFmt() {
            return this.custoUnitario.toLocaleString('pt-br', {
                style: 'currency',
                currency: codigoMoeda(),
                minimumFractionDigits: 4,
            });
        },
    },

    methods: {
        fatorDe(id) {
            const u = this.unidadesMedida.find(e => e.id === id);
            const fator = u ? parseFloat(u.quantidade) : 0;
            return fator > 0 ? fator : 1;
        },

        fillUnidadesMedida() {
            this.$http.get('unidades-medida').then(resp => {
                this.unidadesMedida = resp.data.data;
            })
            .catch(() => {
                this.notify('Verifique sua conexão com a internet', 'warning');
            });
        },

        salvar() {
            const id = this.form.id;

            if (!this.form.nome) {
                this.notify('Informe o nome', 'warning');
                return;
            }

            if (!this.form.unidade_medida_id) {
                this.notify('Informe a unidade de medida', 'warning');
                return;
            }

            const estoqueEmBranco = this.form.estoque === '' || this.form.estoque == null;

            if (this.form.controle_estoque && estoqueEmBranco) {
                this.notify('Informe a quantidade inicial de estoque', 'warning');
                return;
            }

            if (id) {
                this.loading = true;
                this.$http.put(`ingredientes/${id}`, this.form).then(() => {
                    this.$emit('onCadastro');
                    this.$emit('close');
                    this.notify('Atualizado com sucesso!');
                }).catch(() => {
                    this.notify('Verifique sua conexão com a internet', 'warning');
                }).finally(() => (this.loading = false));
                return;
            }

            this.loading = true;
            this.$http.post('ingredientes', this.form).then(() => {
                this.$emit('onCadastro');
                this.notify('Salvo com sucesso!');
                this.reset();
                setTimeout(() => this.$refs.nome.focus(), 100)
            }).catch(() => {
                this.notify('Verifique sua conexão com a internet', 'warning');
            }).finally(() => (this.loading = false));
        },

        newUnidadeMedida() {
            this.formUnidadeMedida = {
                nome: this.searchInput || '',
                abreviacao: '',
                quantidade: '',
            };
            this.unidadeMedidaVisible = true;
        },

        onCadastroUnidadeMedida(undMed) {
            this.unidadeMedidaVisible = false;

            if (undMed) {
                this.unidadesMedida.push(undMed);
                this.form.unidade_medida_id = undMed.id;
            } else {
                this.fillUnidadesMedida();
            }
        },

        closeUnidadeMedida() {
            this.unidadeMedidaVisible = false;
        },

        reset() {
            this.form = {
                ...defaultForm(),
                unidade_medida_id: this.form.unidade_medida_id,
                controle_estoque: this.form.controle_estoque,
                acao_sem_estoque: this.form.acao_sem_estoque,
            };
        },
    },
}
</script>

<style scoped>
.v-card {
    padding: 0 15px 0 15px;
}
</style>
